<template>
    <!-- カート内容確認パーツ -->
    <div class="pt180" id="pt180" v-cloak>
        <breadcrumb :decriptPage="$t('pt180.labels.card')"></breadcrumb>
        <div >
            <div class="itemTitle">
                <h2 v-if="pt180Init.oldOrderCd == null || pt180Init.oldOrderCd == '' ">{{$t('pt180.labels.title')}}</h2>
                <!--注文内容変更オプションの場合-->
                <h2 v-else>{{$t('pt180.labels.checkOrderEdit[0]')}}{{pt180Init.oldOrderCd}}{{$t('pt180.labels.checkOrderEdit[1]')}}</h2>
            </div>
            <!--エラーメッセージ表示領域-->
            <div class="titleErrorMessage">
                <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="'pt180'"/>
            </div>
            
            <div v-if="listReport.length > 0">
                <!-- listReport -->
                <ul role="alert">
                    <li v-for="report in listReport" :key="report">
                        <span class="text-danger">{{report}}</span>
                    </li>
                </ul>
            </div>
            <div v-if="(pt180Init.initialization && pt180Init.initialization.length > 0 && pt180Init.searchList && pt180Init.searchList.length > 0) || (pt180Init.searchPointList && pt180Init.searchPointList.length > 0)">
                <!--カタログコード表示オプション-->
                <div v-if="pt180Init.catalogCdFlg == '1'" class="catalogUl">
                    <span class="catalog">
                        <span class="catalogTitle">{{$t('common.labels.catalogCdNm')}}</span>
                        <input-check class="catalogCdInp" type="text" v-model="pt180ReqModel.catalogCd" :maxlength="10"/>
                    </span>
                </div>
                <!-- 商品一覧 ここから  -->
                <div v-if="pt180Init.searchList.length > 0" class="itemTable" id="cart">
                    <div class="itemHeader">
                        <div class="label divNo">
                            <!--No-->
                            <label class="no">{{$t('common.labels.no')}}</label>
                        </div>
                        <div v-if="pt180Init.itemCdFlg == 1" class="label divItemCd">
                            <!-- 商品番号 -->
                            <label class="itemCd">{{$t('common.labels.productCode')}}</label>
                        </div>
                        <div class="label divItemNm">
                            <!-- ご注文商品名 -->
                            <label class="itemNm">{{$t('common.labels.productName')}}</label>
                        </div>
                        <div class="label divPrice" v-if="pt180Init.priceShow != 1">
                            <!-- 単価  -->
                            <label class="unitPrice">{{$t('common.labels.unitPrice')}}</label>
                        </div>
                        <div class="label divQty">
                            <!-- 数量 -->
                            <label class="quantity">{{$t('common.labels.quantity')}}</label>
                        </div>
                        <div class="label animalQty" v-if="pt180Init.auraOpt == 1">
                            <!-- 匹数 -->
                            <label class="animalQty">{{$t('common.labels.animalQty')}}</label>
                        </div>
                        <div class="label divTax" v-if="pt180Init.priceShow != 1">
                            <!--金額（税込）-->
                            <label v-if="pt180Init.tnkDspKbn ==  '1'" class="tax">{{$t('common.labels.kingakuStr')}}{{$t('common.labels.taxincluded')}}</label>
                            <!--金額（税抜）-->
                            <label v-else class="tax">{{$t('common.labels.kingakuStr')}}{{$t('common.labels.excludingtax')}}</label>
                        </div>
                        <div class="label divItemSelectionType" v-if="pt180Init.catalogQtyGroupOption == 1">
                            <!-- 選択種別 -->
                            <label class="itemSelectionType">{{$t('common.labels.itemSelectionType')}}</label>
                        </div>
                        <div class="label divDelete">
                            <!--削除-->
                            <label class="delete">{{$t('pt180.labels.delete')}}</label>
                        </div>
                    </div>
                    <div class="itemBody">
                        <div v-for="(product, index) in pt180Init.searchList" :key="index" class="itemList">
                            <!--No -->
                            <div class="label divNo" :aria-label="$t('common.labels.no')">
                                {{index + 1}}
                            </div>
                            <!--商品CD-->
                            <div v-if="pt180Init.itemCdFlg == 1" class="label divItemCd" :aria-label="$t('common.labels.productCode')">
                                {{stringNvl(product.M_ITEM_CD,'')}}
                            </div>
                            <!--商品名 -->
                            <div class="label divItemNm" :aria-label="$t('common.labels.productName')">
                                <span class="autoHatchuNgIcon mr-2" v-if="pt180Init.autoHatchuOpt == 1 && product.AUTO_HACHU_FLG == 0"></span>
                                <router-link :to="{ name: SiteConstants.PG030, params:{pageNo: 3, sItemNo: product.KANREN_ORDER_ITEM_CD?product.KANREN_ORDER_ITEM_CD:product.M_ITEM_CD}}">
                                    {{stringNvl(product.WEB_ITEM_NM,'')}}
                                </router-link>
                                <div v-for="(item, idx) in pt180Init.optionList" :key="idx">
                                    <dt v-if="product.SEQ == item.SEQ && product.OPTION_GROUP_CD == item.OP_GP_CD">{{$t(item.OPTION_NAME)}}</dt>
                                </div>
                            </div>
                            <!--単価-->
                            <div class="label divPrice" :aria-label="$t('common.labels.unitPrice')" v-if="pt180Init.priceShow != 1">
                                <!-- 税込みの場合 -->
                                <span v-if="pt180Init.tnkDspKbn == '1'">
                                    {{formatPrice(product.SALE_ZEI_K_TNK)}}{{$t('common.labels.jpYen')}}
                                </span>
                                <span v-else>
                                    {{formatPrice(product.SALE_TNK)}}{{$t('common.labels.jpYen')}}
                                </span>
                            </div>
                            <!--数量 -->
                            <div class="label divQty" :aria-label="$t('common.labels.quantity')" v-if="pt180Init.puldownFlg != 3">
                                <input-check size="5" type="text" :maxlength="5" :id="'qty_' + index" class="qtyInput num" v-model="product.QTY"
                                    @on-change="getAnimalQty(product.QTY, index, product.SYUKKA_NUM)"/>
                            </div>
                            <div class="label divQty" :aria-label="$t('common.labels.quantity')" v-else>
                                <label>{{$t(product.QTY)}}</label>
                            </div>
                            <!--匹数 -->
                            <div class="label animalQty" :aria-label="$t('common.labels.animalQty')" v-if="pt180Init.puldownFlg != 3 && pt180Init.auraOpt == 1">
                                <input-check v-if="product.SYUKKA_NUM > 1" size="7" type="text" :maxlength="7" :id="'animalQty_' + index" class="animalQtyInput num" v-model="product.ANIMAL_QTY"
                                    @on-change="getItemQty(product.ANIMAL_QTY, index, product.SYUKKA_NUM)" :disabled="product.SYUKKA_NUM === 1 ? true : false"/>
                                <span class="animalQtyInput" v-else>
                                    {{"-"}}
                                </span>
                            </div>
                            <!--金額-->
                            <div v-if="pt180Init.tnkDspKbn == '1' && pt180Init.priceShow != 1" class="label divTax" :aria-label="$t('common.labels.kingakuStr') + $t('common.labels.taxincluded')">
                                <span>{{formatPrice(product.ZEI_K_SUBTOTAL)}}{{$t('common.labels.jpYen')}}</span>
                            </div>
                            <div v-else-if="pt180Init.priceShow != 1" class="label divTax" :aria-label="$t('common.labels.kingakuStr') + $t('common.labels.excludingtax')">
                                <span>{{formatPrice(product.SUBTOTAL)}}{{$t('common.labels.jpYen')}}</span>
                            </div>
                            <!-- まとめ買い割引情報 -->
                            <div class="itemMatome" v-if="!common.isNullItem(product.MATOME_TITLE)">
                                <button class="btnSuccess" @click="showMatomeDetail(product)">
                                    <!-- まとめ買い割引情報-->
                                    {{product.MATOME_TITLE}}
                                </button>
                            </div>
                            <!-- 選択種別 -->
                            <div class="label divItemSelectionType" :aria-label="$t('common.labels.itemSelectionType')" v-if="pt180Init.catalogQtyGroupOption == 1">
                                <span>
                                    {{product.QTY_GROUP_KBN}}{{$t('common.labels.itemSelection')}}
                                </span>
                            </div>
                            <!--削除-->
                            <div class="label divDelete">
                                <div class="cartDeleteLink">
                                    <a href="javascript:void(0)" @click="itemDelete(product)">
                                        <!-- 削除ボタン -->
                                        {{$t('pt180.labels.delete')}} 
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 商品一覧 ここまで  -->
                <!-- ポイント商品一覧 ここから  -->
                <div v-if="pt180Init.initialization.length > 0 && pt180Init.searchPointList.length > 0" class="itemTable" id="cart">
                    <div class="itemHeader">
                        <div class="label divNo">
                            <!--No-->
                            <label class="no">{{$t('common.labels.no')}}</label>
                        </div>
                        <div v-if="pt180Init.itemCdFlg == 1" class="label divItemCd">
                            <!-- 商品番号 -->
                            <label class="itemCd">{{$t('common.labels.productCode')}}</label>
                        </div>
                        <div class="label divItemNm">
                            <!-- ご注文商品名 -->
                            <label class="itemNm">{{$t('common.labels.productName')}}</label>
                        </div>
                        <div class="label divPrice" v-if="pt180Init.priceShow != 1">
                            <!-- ポイント  -->
                            <label class="unitPrice">{{$t('pt460.labels.pointsu')}}</label>
                        </div>
                        <div class="label divQty">
                            <!-- 数量 -->
                            <label class="quantity">{{$t('common.labels.quantity')}}</label>
                        </div>
                        <div class="label divTax" v-if="pt180Init.priceShow != 1">
                            <!-- 合計 -->
                            <label class="tax">{{$t('pt460.labels.pointkei')}}</label>
                        </div>
                        <div class="label divDelete">
                            <!--削除-->
                            <label class="delete">{{$t('pt180.labels.delete')}}</label>
                        </div>
                    </div>
                    <div class="itemBody">
                        <div v-for="(product, index) in pt180Init.searchPointList" :key="index" class="itemList">
                            <!--No -->
                            <div class="label divNo" :aria-label="$t('common.labels.no')">
                                {{index + 1}}
                            </div>
                            <!--商品CD-->
                            <div v-if="pt180Init.itemCdFlg == 1" class="label divItemCd" :aria-label="$t('common.labels.productCode')">
                                {{stringNvl(product.M_ITEM_CD,'')}}
                            </div>
                            <!--商品名 -->
                            <div class="label divItemNm" :aria-label="$t('common.labels.productName')">
                                <span class="autoHatchuNgIcon mr-2" v-if="pt180Init.autoHatchuOpt == 1 && product.AUTO_HACHU_FLG == 0"></span>
                                <router-link :to="{ name: SiteConstants.PG030, params:{pageNo: 3, sItemNo: product.KANREN_ORDER_ITEM_CD?product.KANREN_ORDER_ITEM_CD:product.M_ITEM_CD}}">
                                    {{stringNvl(product.WEB_ITEM_NM,'')}}
                                </router-link>
                                <div v-for="(item, idex) in pt180Init.optionList" :key="idex">
                                    <dt v-if="product.SEQ == item.SEQ && product.OPTION_GROUP_CD == item.OP_GP_CD">{{$t(item.OPTION_NAME)}}</dt>
                                </div>
                            </div>
                            <!--ポイント数-->
                            <div class="label divPrice" :aria-label="$t('common.labels.unitPrice')" v-if="pt180Init.priceShow != 1">
                                {{formatPrice(product.RIYO_POINT)}}pt
                            </div>
                            <!--数量 -->
                            <div class="label divQty" :aria-label="$t('common.labels.quantity')" v-if="pt180Init.puldownFlg != 3">
                                <input-check size="5" type="text" :maxlength="5" :id="'qty_' + index" class="qtyInput num" v-model="product.QTY"/>
                            </div>
                            <!--数量 -->
                            <div class="label divQty" :aria-label="$t('common.labels.quantity')" v-else>
                                <label>{{$t(product.QTY)}}</label>
                            </div>
                            <!--金額-->
                            <div v-if="pt180Init.tnkDspKbn == '1' && pt180Init.priceShow != 1" class="label divTax" :aria-label="$t('pt460.labels.pointkei')">
                                {{formatPrice(product.RIYO_POINT * product.QTY)}}pt
                            </div>
                            <!--削除-->
                            <div class="label divDelete">
                                <div class="cartDeleteLink">
                                    <a href="javascript:void(0)" @click="itemDelete(product)">
                                        <!-- 削除ボタン -->
                                        {{$t('pt180.labels.delete')}} 
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- ポイント商品一覧 ここまで  -->
                <div v-if="pt180Init.initialization.length > 0 && pt180Init.searchPointList.length > 0 && pt180Init.priceShow != 1" class="totalPrice">
                    <div class="totalPriceInner">
                        <!-- ポイント合計 -->
                        {{$t('sh060.labels.pointstousethistime')}}
                        <span class="price">
                            {{formatPrice(pt180Init.searchAgainPointList[0].SUBTOTAL_POINT)}}pt
                        </span>
                    </div>
                </div>
                <div  class="totalPrice" v-if="pt180Init.matomeItemCount>0 && pt180Init.priceShow != 1">
                    <div class="totalPriceInner">
                        <!-- まとめ買い割引額 -->
                        {{$t('sh062.labels.matomeNebiki')}}
                        <span class="price">
                            <template >{{formatPrice(pt180Init.searchAgainList[0].SUBTOTAL_MATOME_KIN)}}円</template>
                        </span>
                    </div>
                </div>
                
                <div v-if="pt180Init.totalGivenPointList[0].POINT_NUM > 0 && pt180Init.givenPointFlg == 1" class="totalPrice">
                    <div class="totalPriceInner">
                        <!-- 今回獲得ポイント数 -->
                        {{$t('sh060.labels.totalGivenPointNumTitle')}}
                        <span class="price">
                            {{formatPrice(pt180Init.totalGivenPointList[0].POINT_NUM)}}pt
                        </span>
                    </div>
                </div>
                <div  class="totalPrice" v-if="pt180Init.priceShow != 1">
                    <div class="totalPriceInner">
                        <!-- 合計 -->
                        {{$t('common.labels.total')}}
                        <span class="price">
                            <template v-if="pt180Init.tnkDspKbn == '1'">{{formatPrice(pt180Init.searchAgainList[0].SUBTOTAL_ZEI_K_KIN)}}円</template>
                            <template v-else>{{formatPrice(pt180Init.searchAgainList[0].SUBTOTAL_KIN)}}円</template>
                        </span>
                    </div>
                </div>

                <ul id="cart-nav-list" class="btnRow" ontouchstart="">
                    <li>
                        <!-- 購入数更新 -->
                        <input v-if="pt180Init.puldownFlg != 3" class="btnSubmit" name="update" @click="updateAll()" type="submit" :value="$t('pt180.buttons.updateAll')">
                    </li>
                    <li>
                        <!--買い物を続ける -->
                        <input class="btnSubmit" type="submit" @click="backStep()" :value="$t('pt180.buttons.continueToOrder')">
                    </li>
                    <li>
                        <!-- カートを空にする -->
                        <input class="btnSubmit back-btn" name="delete_all" @click="deleteAll()" type="submit" :value="$t('pt180.buttons.deleteAll')">
                    </li>
                    <li v-if="pt180Init.oldOrderCd">
                        <!-- 注文変更やめるを空にする -->
                        <input class="btnSubmit back-btn" name="delete_all" @click="clearAllWork()" type="submit" :value="$t('pt180.buttons.clearAllWork')">
                    </li>
                    <!-- ステップ型遷移利用なし：ご注文手続きへ -->
                    <template v-if="pt180Init.stepBasedFlg != 1">
                        <!-- 注文変更の場合 -->
                        <li id="cart-nav-regi" v-if="pt180Init.oldOrderCd">
                            <!--ご注文手続きへ -->
                            <input class="btnSubmit" v-if="pt180Init.oldReceiptNo == null || pt180Init.oldReceiptNo == '' || pt180Init.oldReceiptNo == undefined" type="submit" @click="buyStep()" :value="$t('pt180.buttons.orderProcedure')">
                            <div v-if="pt180Init.oldKessaiCd == '83' " style="margin-top:12px;" id="AmazonPayButton"/>
                        </li>
                        <li id="cart-nav-regi" v-else>
                            <!--ご注文手続きへ -->
                            <input class="btnSubmit" v-if="pt180Init.oldReceiptNo == null || pt180Init.oldReceiptNo == '' || pt180Init.oldReceiptNo == undefined" type="submit" @click="buyStep()" :value="$t('pt180.buttons.orderProcedure')">
                            <div v-if="pt180Init.amazonPayFlg == '1' " style="margin-top:12px;" id="AmazonPayButton"/>
                        </li>
                    </template>
                    <!-- ステップ型遷移利用あり：複数お届先指定可能条件で分岐 -->
                    <template v-else>
                        <!-- 複数お届先指定可能条件に合致する場合：1つの住所に送る・複数の住所に送る -->
                        <template v-if="pt180Init.hukusuFlg == 1
                            && pt180Init.amazonPayFlg != 1
                            && !(pt180Init.cartSplitUseFlg == 1 && pt180Init.onlyStorePickupFlg == 1)">
                            <li id="cart-nav-regi-sgl">
                                <!--１つの住所に送る -->
                                <input class="btnSubmit" type="submit" @click="gotoSingleAddress()" :value="$t('pt180.buttons.shipToSingleAddress')">
                            </li>
                            <li id="cart-nav-regi-mlt">
                                <!--複数の住所に送る -->
                                <input class="btnSubmit" type="submit" @click="gotoMultipleAddresses()" :value="$t('pt180.buttons.shipToMultipleAddresses')" :disabled="isGuestKokyaku()">
                            </li>
                            <!-- ゲスト向け複数住所注釈 -->
                            <li id="cart-nav-regi-guest-note" v-if="isGuestKokyaku()">
                                <span>{{$t('pt180.labels.multipleAddressGuestNote')}}</span>
                            </li>
                        </template>
                        <!-- 複数お届先指定可能条件に合致しない場合：ご注文手続きへ（SH030へ遷移） -->
                        <template v-else>
                            <li id="cart-nav-regi">
                                <!--ご注文手続きへ -->
                                <input class="btnSubmit" type="submit" @click="gotoSingleAddress()" :value="$t('pt180.buttons.orderProcedure')">
                            </li>
                        </template>
                    </template>
                </ul>
                <ul class="footerMessenge" id="cart-summary">
                    <li> {{$t('pt180.labels.messenge')}}  </li>
                </ul>
                <ul id="cart-nav-list" class="btnRow" ontouchstart="" v-if="pt180Init.quotationFlg == 1">
                    <li id="cart-nav-regi">
                        <!--見積書作成へ -->
                        <input class="btnSubmitStep" type="submit" @click="quotationStep()" :value="$t('pt180.buttons.quotationButton')">
                    </li>
                </ul>

            </div>
            <div v-else id="main-contents">
                <div class="footerErrorMessenge">
                    <div class="sectionInner">
                        <!--エラーメッセージ表示枠 ここから  -->
                        <div v-if="(pt180Init.searchList == null || pt180Init.searchList.length == 0) && (pt180Init.errList == null || pt180Init.errList.length == 0) && isInited">
                            <ul class="footerErrorDetail">
                                <!-- カートに商品はありません。 -->
                                <li>{{$t('pt180.labels.noOrderMessg')}}</li>
                            </ul>
                        </div>
                        <div class="backBtn">
                            <input class="btnSubmit" type="submit" @click="backStep()" :value="$t('pt180.buttons.continueToOrder')">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
/* eslint-disable */
/*
* Import libs and componnents
*/
import $ from 'jquery';
import axios from "assets/js/request";
import DataTable from 'components/Datatable';
import common from 'assets/js/common';
import BackButton from 'components/BackButton';
import EventBus from 'assets/js/eventBus';
import Message from 'components/MessageEcSite';
import InputCheck from 'components/InputCheck.vue';
import DownloadFile from 'components/DownloadFile';
import PageFeed from "../commonParts/PageFeed";
import SiteConstants from 'assets/const/SiteConstants.json';
import InputNumber from 'components/InputNumber';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import commonEc from "assets/js/common_ec";
import { mapMutations } from 'vuex';

export default {
    /*
    * Name of component
    */
    name: "pt180",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        },
    },
    /* 
    * Declare components
    */
    components: {
        DataTable,
        BackButton,
        Message: Message,
        InputCheck,
        DownloadFile,
        PageFeed,
        InputNumber,
        Breadcrumb
    },
    watch: {
        pt180Init: {
            handler(value) {
                this.syncPt180InitState(value);
            },
            deep: true,
            immediate: true,
        },
        pt180ReqModel: {
            handler(value) {
                this.syncPt180ReqModelState(value);
            },
            deep: true,
            immediate: true,
        },
    },
    /*
    * Declare variable and set default value
    */
    data: function() {
        return {
            isDisplay: false,
            isDownload: false,
            common : common,
            backPageNo: 0,
            categoryCd: null,
            ptPageNo: 1,
            ptPageSize: 10,
            searchItemNm: null,
            itemNmOnly: null,
            priceS: null,
            priceE: null,
            allergyMaterialKbn: null,
            zaikoSearchFlg: null,
            pt180ReqModel: {
                pageNo: null,
                pageSize: null,
                info: null,
                catalogCd: '',
                itemCd: null,
                qty: 1
            },
            pt460reqModel:{

            },
            pt180Init: {
                pageNo: null,
                pageSize: null,
                searchAgainList:[{}],
                searchAgainPointList:[{}],
                searchList:[],
                searchPointList:[],
                matomeItemCount: 0,
                initialization:[],
                orderEditFlg: 0,
                catalogCdFlg: '0',
                catalogCdRequiredFlg: '0',
                quotationFlg: 0,
                kokyakuKbn: '',
                catalogQtyGroupOption:0
            },
            isModalShow:false,
            msgConfirm:'',
            queryData:null,
            PT180_PART:'pt180',
            listMessValid:[],
            mapMessValid:[],
            listIdErr:[],
            listReport:[],
            UPDATE_PROCESS : 0,
            BUY_STEP_PROCESS:1,
            CONTINUE_TO_ORDER_PROCESS:2,
            GUEST_KOKYAKU_NO:"999999999",
            SiteConstants: SiteConstants,
            isInited:false,
            site: "",
            pt440Info: "",
            partInitData: null,
            commonEc:commonEc
        }
    },
    /*
    * Initialize
    */
    mounted: async function() {
        var _this = this;
        sessionStorage.removeItem('doQuotation');
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        // バナーから遷移してきた場合、カートに商品を追加。
        if(_this.pt180ReqModel.pageNo == _this.SiteConstants.SHOPPER_CART_PAGE && _this.pt180ReqModel.itemCd != null){
            await _this.itemInsert();
        }

        if (_this.ptInitData){
            _this.pt180Init = _this.ptInitData;

            //遠鉄個人ポイント付与数 表示
            if (_this.pt180Init.entetsuFlg == 1 && _this.pt180Init.entetsuAutoLoginFlg == 1){
                //kainInfo存在は遠鉄個人です
                if (sessionStorage.getItem('kainInfo')){
                    let entetsuKainInfo = JSON.parse(sessionStorage.getItem('kainInfo'));
                    if (_this.pt180Init.givenPointFlg == 1){
                        _this.pt180Init.givenPointFlg = entetsuKainInfo.pointPlusFlg;
                    }
                }
            }
            
            _this.pt180ReqModel = Object.assign({}, _this.pt180ReqModel, _this.ptInitData.reqModel);
            if(_this.ptInitData.errList != null && _this.ptInitData.errList.length > 0){
                _this.displayWaring(_this.ptInitData.errList);
            }

            if (_this.pt180Init.searchList != null || _this.pt180Init.searchList != undefined) {
                for(var i = 0; i < _this.pt180Init.searchList.length; i++){
                    var product = _this.pt180Init.searchList[i];
                    _this.pt180ReqModel.catalogCd = product.MEDIA_CD;
                    break;
                }
            }
            
            // AmazonPayボタンを表示(0だったら非表示)
            if (_this.pt180Init.amazonPayFlg == '1') {
                if (_this.pt180Init && _this.pt180Init.searchList) {
                    _this.buyStepAmazon();
                }
                // Dynamically load the Amazon Pay SDK script
                const script = document.createElement('script');
                script.src = 'https://static-fe.payments-amazon.com/checkout.js';
                script.async = true;
                document.head.appendChild(script);
                // Wait for the script to be loaded before rendering the button
                script.onload = () => {
                    // Check if the AmazonPay object is available
                    if (sessionStorage['amazonCheckoutSessionId'] == null) {
                        amazon.Pay.renderButton('#AmazonPayButton', {
                            // set checkout environment
                            merchantId: _this.pt180Init.merchantId,
                            ledgerCurrency: 'JPY',
                            // customize the buyer experience
                            checkoutLanguage: 'ja_JP',
                            productType: 'PayAndShip',
                            placement: 'Checkout',
                            buttonColor: 'Gold',
                            // configure Create Checkout Session request
                            createCheckoutSessionConfig: {        
                                payloadJSON: _this.pt180Init.payloadJson,
                                signature: _this.pt180Init.signature, 
                                publicKeyId: _this.pt180Init.publicKeyId
                            }   
                        });
                    } else {
                        amazon.Pay.renderButton('#AmazonPayButton', {
                            // set checkout environment
                            merchantId: _this.pt180Init.merchantId,
                            ledgerCurrency: 'JPY',       
                            // customize the buyer experience
                            checkoutLanguage: 'ja_JP',
                            productType: 'PayAndShip',
                            placement: 'Checkout',
                            buttonColor: 'Gold'
                        });
                    }
                    
                };
            }
            _this.isInited=true;
        }else{
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT180 + _this.$UrlConstants.DO_INIT, _this.pt180ReqModel).then(function(response) {
                _this.pt180Init = response.data;
                
                //遠鉄個人ポイント付与数 表示
                if (_this.pt180Init.entetsuFlg == 1 && _this.pt180Init.entetsuAutoLoginFlg == 1){
                    //kainInfo存在は遠鉄個人です
                    if (sessionStorage.getItem('kainInfo')){
                        let entetsuKainInfo = JSON.parse(sessionStorage.getItem('kainInfo'));
                        if (_this.pt180Init.givenPointFlg == 1){
                            _this.pt180Init.givenPointFlg = entetsuKainInfo.pointPlusFlg;
                        }
                    }
                }

                _this.pt180ReqModel = Object.assign({}, _this.pt180ReqModel, response.data.reqModel);
                if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWaring(response.data.errList);
                }

                if (_this.pt180Init.searchList != null || _this.pt180Init.searchList != undefined) {
                    for(var i = 0; i < _this.pt180Init.searchList.length; i++){
                        var product = _this.pt180Init.searchList[i];
                        _this.pt180ReqModel.catalogCd = product.MEDIA_CD;
                        break;
                    }
                }
                
                // AmazonPayボタンを表示(0だったら非表示)
                if (_this.pt180Init.amazonPayFlg == '1') {
                    // Dynamically load the Amazon Pay SDK script
                    const script = document.createElement('script');
                    script.src = 'https://static-fe.payments-amazon.com/checkout.js';
                    script.async = true;
                    document.head.appendChild(script);
                    // Wait for the script to be loaded before rendering the button
                    script.onload = () => {
                        // Check if the AmazonPay object is available
                        amazon.Pay.renderButton('#AmazonPayButton', {
                            // set checkout environment
                            merchantId: _this.pt180Init.merchantId,
                            ledgerCurrency: 'JPY',            
                            // customize the buyer experience
                            checkoutLanguage: 'ja_JP',
                            productType: 'PayAndShip',
                            placement: 'Checkout',
                            buttonColor: 'Gold',
                            // configure Create Checkout Session request
                            createCheckoutSessionConfig: {        
                                payloadJSON: _this.pt180Init.payloadJson,
                                signature: _this.pt180Init.signature, 
                                publicKeyId: _this.pt180Init.publicKeyId
                            }   
                        });
                    };
                }
                _this.isInited=true;
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }
        
        if (_this.pt180Init.reqModel.orderCdTypical != null && _this.pt180Init.reqModel.orderCdTypical != undefined && _this.pt180Init.reqModel.orderCdTypical != '') {
            // 非ログインの場合ログイン画面へ
            if (_this.isGuestKokyaku()) {
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 18, returnFlg:1, fromCart:1,orderCdTypical:_this.pt180Init.reqModel.orderCdTypical, kokyakuNo:_this.pt180Init.reqModel.kokyakuNo, fBaFLG:_this.pt180Init.reqModel.fBaFLG}});
            } else {
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 22, reOrderFlg:1}});
            }
        }
        
        _this.countMatomeItem();

        _this.$emit('evt-change-quantily');
    },
    /*
    * Methods
    */
    methods: {
        ...mapMutations('pt180', {
            commitSetPt180Init: 'SET_PT180_INIT',
            commitSetPt180ReqModel: 'SET_PT180_REQ_MODEL',
        }),
        syncPt180InitState(value) {
            this.commitSetPt180Init(value ? Object.assign({}, value) : {});
        },
        syncPt180ReqModelState(value) {
            this.commitSetPt180ReqModel(value ? Object.assign({}, value) : {});
        },
        // ゲスト（未ログイン）判定。引数省略時は pt180Init.kokyakuNo を参照
        isGuestKokyaku(kokyakuNo = this.pt180Init.kokyakuNo) {
            return kokyakuNo == this.GUEST_KOKYAKU_NO || kokyakuNo == '0';
        },
        /*
        * まとめ買い割引詳細画面へ
        */
        showMatomeDetail: function(product){
            var _this = this;
            var matomeCd = product.MATOME_CD;
            _this.$emit("event-loading", true);
            var ptPageNo = _this.ptPageNo;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 27, matomeCd: matomeCd, backPageNo: ptPageNo}});
        },
        countMatomeItem: function(){
            var _this = this;
            var count = 0;
            if(_this.pt180Init.searchList != null || _this.pt180Init.searchList != undefined){
                for(var p = 0; p < _this.pt180Init.searchList.length; p++){
                    var product = _this.pt180Init.searchList[p];
                    if(!common.isNullItem(product.MATOME_TITLE)){
                        count++;
                    }   
                }
            }
            if(_this.pt180Init.searchList != null || _this.pt180Init.searchList != undefined){
                for(var p = 0; p < _this.pt180Init.searchPointList.length; p++){
                    var product = _this.pt180Init.searchPointList[p];
                    if(!common.isNullItem(product.MATOME_TITLE)){
                        count++;
                    }   
                }
            }
            _this.pt180Init.matomeItemCount = count;
        },
        itemChange: function(product){
            var _this = this;
            var order = {};
            order.seqNo = product.SEQ;
            order.lineNo = product.SEQ;
            order.qty = product.QTY;
            order.itemNmHid = product.WEB_ITEM_NM
            order.sItemNo = product.M_ITEM_CD;
            //list product
            var orderItems = [];
            orderItems.push(order);

            var reqModel = {};
            reqModel.processType = _this.UPDATE_PROCESS;
            reqModel.orderItems = orderItems;
            _this.$emit("event-loading", true);
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT180_PART);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT180 + _this.$UrlConstants.DO_UPDATE, reqModel).then(function(response) {
                if(response.data.status == 'OK'){
                    _this.pt180Init.searchList = response.data.response.searchList;
                    _this.pt180Init.searchPointList = response.data.response.searchPointList;
                    _this.countMatomeItem();
                    _this.pt180Init.searchAgainList = response.data.response.searchAgainList;
                    _this.pt180Init.searchAgainPointList = response.data.response.searchAgainPointList;
                    _this.pt180Init.totalGivenPointList = response.data.response.totalGivenPointList;
                    // send event to pt050
                    _this.$emit('evt-change-quantily');
                }
                
                if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWaring(response.data.errList);
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        itemDelete: function(product){
            var _this = this;
            _this.$emit("event-loading", true);
            var reqModel = {};
            reqModel.delSeq = product.SEQ;
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT180_PART);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT180 + _this.$UrlConstants.DO_DELETE, reqModel).then(function(response) {
                if(response.data.status == 'OK'){
                    _this.pt180Init.searchList = response.data.response.searchList;
                    _this.pt180Init.searchPointList = response.data.response.searchPointList;
                    _this.countMatomeItem();
                    _this.pt180Init.searchAgainList = response.data.response.searchAgainList;
                    _this.pt180Init.searchAgainPointList = response.data.response.searchAgainPointList;
                    // send event to pt050
                    _this.$emit('evt-change-quantily');
                }
                if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWaring(response.data.errList);
                }
                if (_this.pt180Init.amazonPayFlg == '1') {
                    location.reload();
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        updateAll: function(){
            var _this = this;
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT180_PART);
            _this.$emit("event-loading", true);
            var orderItems = [];
            if (_this.pt180Init && _this.pt180Init.searchList && _this.pt180Init.amazonPayFlg == '1') {
                _this.buyStepAmazon();
            }
            for(var p = 0; p < _this.pt180Init.searchList.length; p++){
                var product = _this.pt180Init.searchList[p];
                var order = {};
                order.seqNo = product.SEQ;
                order.lineNo = product.SEQ;
                order.qty = product.QTY;
                order.itemNmHid = product.WEB_ITEM_NM
                order.sItemNo = product.M_ITEM_CD;
                order.cartAddKbn = product.CART_ADD_KBN;
                order.pointFlg = product.POINT_FLG;
                order.riyouPoint = product.RIYO_POINT;
                order.animalQty = product.ANIMAL_QTY;
                order.notSyukkaFlg = product.NOT_SYUKKA_FLG;
                orderItems.push(order);
            }
            for(var p = 0; p < _this.pt180Init.searchPointList.length; p++){
                var product = _this.pt180Init.searchPointList[p];
                var order = {};
                order.seqNo = product.SEQ;
                order.lineNo = product.SEQ;
                order.qty = product.QTY;
                order.itemNmHid = product.WEB_ITEM_NM
                order.sItemNo = product.M_ITEM_CD;
                order.cartAddKbn = product.CART_ADD_KBN;
                order.pointFlg = product.POINT_FLG;
                order.riyouPoint = product.RIYO_POINT;
                order.animalQty = product.ANIMAL_QTY;
                order.notSyukkaFlg = product.NOT_SYUKKA_FLG;
                orderItems.push(order);
            }

            var reqModel = {};

            reqModel.orderItems = orderItems;
            reqModel.processType = _this.UPDATE_PROCESS;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT180 + _this.$UrlConstants.DO_UPDATE, reqModel).then(function(response) {

                if(response.data.status == 'OK'){
                    _this.pt180Init.searchList = response.data.response.searchList;
                    _this.pt180Init.searchPointList = response.data.response.searchPointList;
                    _this.countMatomeItem();
                    _this.pt180Init.searchAgainList = response.data.response.searchAgainList;
                    _this.pt180Init.searchAgainPointList = response.data.response.searchAgainPointList;
                    _this.pt180Init.totalGivenPointList = response.data.response.totalGivenPointList;
                } else if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWaring(response.data.errList);
                }
                
                _this.$emit('evt-change-quantily');
                _this.$emit("event-loading", false);
                _this.$forceUpdate();

            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        deleteAll: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            var reqModel = {};
            reqModel.delSeq = 0;
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT180_PART);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT180 + _this.$UrlConstants.DO_DELETE, reqModel).then(function(response) {
                if(response.data.status == 'OK'){
                    _this.pt180Init.searchList = response.data.response.searchList;
                    _this.pt180Init.searchPointList = response.data.response.searchPointList;
                    _this.countMatomeItem();
                    _this.pt180Init.searchAgainList = response.data.response.searchAgainList;
                    _this.pt180Init.searchAgainPointList = response.data.response.searchAgainPointList;
                    sessionStorage.removeItem('hopeDayList');
                    sessionStorage.removeItem('totalPointKin');
                    // send event to pt050
                    _this.$emit('evt-change-quantily');
                }
                if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWaring(response.data.errList);
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        clearAllWork: function(){
            var _this = this;
            _this.$emit("event-loading", true);
            var reqModel = {};
            reqModel.delSeq = 0;
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT180_PART);
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT180 + _this.$UrlConstants.DO_DELETE_ALL, reqModel).then(function(response) {
                if(response.data.status == 'OK'){
                    _this.pt180Init.searchList = response.data.response.searchList;
                    _this.pt180Init.searchPointList = response.data.response.searchPointList;
                    _this.countMatomeItem();
                    _this.pt180Init.searchAgainList = response.data.response.searchAgainList;
                    _this.pt180Init.searchAgainPointList = response.data.response.searchAgainPointList;
                    // send event to pt050
                    _this.$emit('evt-change-quantily');
                }
                if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWaring(response.data.errList);
                }
                _this.pt180Init.oldOrderCd = null;
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        itemInsert: async function(){
            var _this = this;
            // URLを通常時のものに変更する。
            history.replaceState('','', _this.SiteConstants.PG010MAIN+'?pageNo='+_this.SiteConstants.SHOPPER_CART_PAGE);

            _this.$emit("event-loading", true);
            if(_this.pt180ReqModel.qty == ''){
                _this.pt180ReqModel.qty = 0;
            }
            //Call API insert
            await axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT180 + _this.$UrlConstants.DO_INSERT, _this.pt180ReqModel).then(function(response) {
                if(response.data.status == 'OK'){
                    _this.pt180Init.searchList = response.data.response.searchList;
                    _this.pt180Init.searchPointList = response.data.response.searchPointList;
                    _this.countMatomeItem();
                    _this.pt180Init.searchAgainList = response.data.response.searchAgainList;
                    _this.pt180Init.searchAgainPointList = response.data.response.searchAgainPointList;
                    // send event to pt050
                    _this.$emit('evt-change-quantily');
                }
                if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWaring(response.data.errList);
                } else {
                    location.reload();
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        backStep: function(){
            var _this = this;
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT180_PART);
            //カートが空の場合
            if(_this.pt180Init.searchList == null || _this.pt180Init.searchList.length == 0){
                _this.pageStep();
            }
            _this.$emit("event-loading", true);
            var orderItems = [];
            for(var p = 0; p < _this.pt180Init.searchList.length; p++){
                var product = _this.pt180Init.searchList[p];
                var order = {};
                order.seqNo = product.SEQ;
                order.lineNo = product.SEQ;
                order.qty = product.QTY;
                order.itemNmHid = product.WEB_ITEM_NM
                order.sItemNo = product.M_ITEM_CD;
                order.cartAddKbn = product.CART_ADD_KBN;
                order.pointFlg = product.POINT_FLG;
                order.riyouPoint = product.RIYO_POINT;
                order.animalQty = product.ANIMAL_QTY;
                order.notSyukkaFlg = product.NOT_SYUKKA_FLG;
                orderItems.push(order);
            }
            for(var p = 0; p < _this.pt180Init.searchPointList.length; p++){
                var product = _this.pt180Init.searchPointList[p];
                var order = {};
                order.seqNo = product.SEQ;
                order.lineNo = product.SEQ;
                order.qty = product.QTY;
                order.itemNmHid = product.WEB_ITEM_NM
                order.sItemNo = product.M_ITEM_CD;
                order.cartAddKbn = product.CART_ADD_KBN;
                order.pointFlg = product.POINT_FLG;
                order.riyouPoint = product.RIYO_POINT;
                order.animalQty = product.ANIMAL_QTY;
                order.notSyukkaFlg = product.NOT_SYUKKA_FLG;
                orderItems.push(order);
            }

            var reqModel = {};
            reqModel.processType = _this.CONTINUE_TO_ORDER_PROCESS;
            reqModel.orderItems = orderItems;

            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT180 + _this.$UrlConstants.DO_UPDATE, reqModel).then(function(response) {
                if(response.data.status == 'OK'){
                    _this.pageStep();
                }
                if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWaring(response.data.errList);
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /*
        * 購入手続きへ処理
        */
        buyStep: function(addressMode){
            var _this = this;
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT180_PART);
            _this.$emit("event-loading", true);
            sessionStorage['doQuotation']=0;
            // カタログコード必須オプションの場合
            if (_this.pt180Init.catalogCdRequiredFlg == '1' && _this.pt180ReqModel.catalogCd == ''
                || _this.pt180Init.catalogCdRequiredFlg == '1' && _this.pt180ReqModel.catalogCd == null) {
                alert(_this.$i18n.t('common.messages.catalogRequired'));
                _this.$emit("event-loading", false);
                return;
            }
            // 請求金額が10桁を超える場合
            if (_this.pt180Init.searchAgainList[0].SUBTOTAL_ZEI_K_KIN > 999999999 || _this.pt180Init.searchAgainList[0].SUBTOTAL_KIN > 999999999) {
                alert(_this.$i18n.t('common.messages.totalAmountOver'));
                _this.$emit("event-loading", false);
                return;
            }
            var orderItems = [];
            for(var p = 0; p < _this.pt180Init.searchList.length; p++){
                var product = _this.pt180Init.searchList[p];
                var order = {};
                order.seqNo = product.SEQ;
                order.lineNo = product.SEQ;
                order.qty = product.QTY;
                order.itemNmHid = product.WEB_ITEM_NM
                order.sItemNo = product.M_ITEM_CD;
                order.cartAddKbn = product.CART_ADD_KBN;
                order.pointFlg = product.POINT_FLG;
                order.riyouPoint = product.RIYO_POINT;
                order.animalQty = product.ANIMAL_QTY;
                order.notSyukkaFlg = product.NOT_SYUKKA_FLG;
                orderItems.push(order);
            }
            for(var p = 0; p < _this.pt180Init.searchPointList.length; p++){
                var product = _this.pt180Init.searchPointList[p];
                var order = {};
                order.seqNo = product.SEQ;
                order.lineNo = product.SEQ;
                order.qty = product.QTY;
                order.itemNmHid = product.WEB_ITEM_NM
                order.sItemNo = product.M_ITEM_CD;
                order.cartAddKbn = product.CART_ADD_KBN;
                order.pointFlg = product.POINT_FLG;
                order.riyouPoint = product.RIYO_POINT;
                order.animalQty = product.ANIMAL_QTY;
                order.notSyukkaFlg = product.NOT_SYUKKA_FLG;
                orderItems.push(order);
            }

            var reqModel = {};
            
            reqModel.processType = _this.BUY_STEP_PROCESS;
            reqModel.checkAddShouhinFlg = 1;
            reqModel.orderItems = orderItems;
            reqModel.catalogCd = _this.pt180ReqModel.catalogCd;
            reqModel.addressMode = addressMode || null;
            _this.listReport = [];
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT180 + _this.$UrlConstants.DO_NEXT_BUY_STEPS, reqModel).then(function(response) {
                if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWaring(response.data.errList);
                }
                if(response.data.status == 'OK'){
                    var tdkYmdInfoDeleteFlg = response.data.response.tdkYmdInfoDeleteFlg;
                    if (tdkYmdInfoDeleteFlg !== null && tdkYmdInfoDeleteFlg === true) {
                        alert('定期商品が含まれるため、お届け日の設定をクリアしました。再度ご指定ください。');
                    }
                    // 非ログインの場合ログイン画面へ
                    if (_this.isGuestKokyaku(response.data.response.kokyakuNo)) {
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 18, returnFlg:1, fromCart:1}});
                    } else {
                        var nextPageNo = response.data.response.nextPageNo;
                        var params = {backPageNo: 16, motoPageId: 'pt180'};
                        var query = {pageNo: nextPageNo, backPageNo: 16};
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: query, params: params });
                   }
                } else{
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 16}});
                }
                
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },
        /*
        * ステップ型遷移：1つの住所に送る処理（SH030へ遷移）
        */
        gotoSingleAddress: function(){
            this.buyStep('single');
        },
        /*
        * ステップ型遷移：複数の住所に送る処理（SH040へ遷移）
        */
        gotoMultipleAddresses: function(){
            this.buyStep('multiple');
        },
        /*
        * AmazonPay購入手続きへ処理
        */
        buyStepAmazon: function(){
            var _this = this;
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT180_PART);
            _this.$emit("event-loading", true);
            sessionStorage['doQuotation']=0;
            var orderItems = [];
            for(var p = 0; p < _this.pt180Init.searchList.length; p++){
                var product = _this.pt180Init.searchList[p];
                var order = {};
                order.seqNo = product.SEQ;
                order.lineNo = product.SEQ;
                order.qty = product.QTY;
                order.itemNmHid = product.WEB_ITEM_NM
                order.sItemNo = product.M_ITEM_CD;
                order.cartAddKbn = product.CART_ADD_KBN;
                order.pointFlg = product.POINT_FLG;
                order.riyouPoint = product.RIYO_POINT;
                order.animalQty = product.ANIMAL_QTY;
                order.notSyukkaFlg = product.NOT_SYUKKA_FLG;
                orderItems.push(order);
            }
            for(var p = 0; p < _this.pt180Init.searchPointList.length; p++){
                var product = _this.pt180Init.searchPointList[p];
                var order = {};
                order.seqNo = product.SEQ;
                order.lineNo = product.SEQ;
                order.qty = product.QTY;
                order.itemNmHid = product.WEB_ITEM_NM
                order.sItemNo = product.M_ITEM_CD;
                order.cartAddKbn = product.CART_ADD_KBN;
                order.pointFlg = product.POINT_FLG;
                order.riyouPoint = product.RIYO_POINT;
                order.animalQty = product.ANIMAL_QTY;
                order.notSyukkaFlg = product.NOT_SYUKKA_FLG;
                orderItems.push(order);
            }
            var reqModel = {};
            
            reqModel.processType = _this.BUY_STEP_PROCESS;
            reqModel.orderItems = orderItems;
            reqModel.catalogCd = _this.pt180ReqModel.catalogCd;
            reqModel.oldReceiptNo = _this.pt180Init.oldReceiptNo;
            _this.listReport = [];
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT180 + _this.$UrlConstants.DO_NEXT_BUY_STEPS, reqModel).then(function(response) {
                _this.$emit("event-loading", false);
                if (sessionStorage['amazonCheckoutSessionId'] != null || (_this.pt180Init.oldReceiptNo != null && pt180Init.oldReceiptNo != '')) {
                    if(response.data.status == 'OK'){
                        // 非ログインの場合ログイン画面へ
                        if (_this.isGuestKokyaku(response.data.response.kokyakuNo)) {
                            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 18, returnFlg:1, fromCart:1, amazonCheckoutSessionId:sessionStorage['amazonCheckoutSessionId'] }});
                        }
                    }
                }
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
                
            });
        },
        pageStep: function () {
            var _this = this;
            var site = _this.site;
            var pg010 = _this.SiteConstants.PG010MAIN;
            var pg020 = _this.SiteConstants.PG010MAIN;
            var pg040 = _this.SiteConstants.PG010MAIN;
            var backPageNo = _this.backPageNo;
            var categoryCd = _this.categoryCd;
            var ptPageNo = _this.ptPageNo;
            var ptPageSize = _this.ptPageSize;
            var searchItemNm = _this.searchItemNm;
            var itemNmOnly = _this.itemNmOnly;
            var priceS = _this.priceS;
            var priceE = _this.priceE;
            var allergyMaterialKbn = _this.allergyMaterialKbn;
            var zaikoSearchFlg = _this.zaikoSearchFlg;
            // クイックオーダー画面へ
            if (backPageNo == 6) {
                _this.$router.push({ name: pg040, query: {pageNo: backPageNo}});
            // お気に入り画面へ
            } else if (backPageNo == 7) {
                _this.$router.push({ name: pg040, query: {pageNo: backPageNo, ptPageNo: ptPageNo, ptPageSize: ptPageSize}});
            // カテゴリ検索した商品一覧へ
            } else if (categoryCd != null) {
                _this.$router.push({ name: pg020, query: {pageNo:2, categoryCd: categoryCd, searchItemNm: searchItemNm
                                    , ptPageNo: ptPageNo, ptPageSize: ptPageSize, itemNmOnly:itemNmOnly, priceS: priceS, priceE: priceE, allergyMaterialKbn: allergyMaterialKbn,zaikoSearchFlg:zaikoSearchFlg}});
            // 通常検索した商品一覧へ
            } else if (searchItemNm != null) {
                _this.$router.push({ name: pg020, query: {pageNo:2, searchItemNm: searchItemNm, ptPageNo: ptPageNo
                                    , ptPageSize: ptPageSize, allergyMaterialKbn: allergyMaterialKbn,zaikoSearchFlg:zaikoSearchFlg}});
            // 詳細検索した商品一覧へ
            } else if (itemNmOnly != null || priceS != null || priceE != null) {
                _this.$router.push({ name: pg020, query: {pageNo:2, ptPageNo: ptPageNo, ptPageSize: ptPageSize
                                    , categoryCd: categoryCd, itemNmOnly: itemNmOnly, priceS: priceS, priceE: priceE, allergyMaterialKbn: allergyMaterialKbn,zaikoSearchFlg:zaikoSearchFlg}});
            } else {
                _this.$router.push({ name: pg010, query: {pageNo:1}});
            }
        },
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
        /* 
        * Function displayWaring 
        * analyst data message and display
        */
        displayWaring(errorList){
            this.listReport = [];
            // check error list
            if(errorList != null && errorList.length > 0){
                //var errorList = error.response.data.errorList;
                for(var index =0;  index < errorList.length; index ++){
                    // replace messenge
                    var messageList = errorList[index].messageList;
                    if(messageList != null && messageList.length > 0){
                        for (var mesInx = 0; mesInx < messageList.length; mesInx++){
                            var msgTemp = messageList[mesInx].message;
                            this.listReport.push(msgTemp);
                            
                        }
                    }
                }
                return this.listReport;
            }
        },
        formatPrice: function(value){
            return common.formatPrice(value);
        },
        /* 
        * Function nvl for string item 
        */
        stringNvl: function(item, def){
            if(item == null || item == undefined){
                return def;
            }
            return item;
        },
        /* 
        * 匹数から数量を算出する
        */
        getItemQty: async function(qty, index, syukkaNum){
            var _this = this;
            if(_this.pt180Init.auraOpt == 1){
                _this.pt180Init.searchList[index].QTY = (await commonEc.getItemQty(qty, syukkaNum)) % 1 !== 0 ? _this.pt180Init.searchList[index].QTY : await commonEc.getItemQty(qty, syukkaNum);
            }
        },
        /* 
        * 数量から匹数を算出する
        */
        getAnimalQty: async function(qty, index, syukkaNum){
            var _this = this;
            if(_this.pt180Init.auraOpt == 1){
                _this.pt180Init.searchList[index].ANIMAL_QTY = await commonEc.getAnimalQty(qty, syukkaNum);
            }
        },
        quotationStep: function(){
            var _this = this;
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT180_PART);
            _this.$emit("event-loading", true);
            sessionStorage['doQuotation']=1;
            // カタログコード必須オプションの場合
            if (_this.pt180Init.catalogCdRequiredFlg == '1' && _this.pt180ReqModel.catalogCd == ''
                || _this.pt180Init.catalogCdRequiredFlg == '1' && _this.pt180ReqModel.catalogCd == null) {
                alert(_this.$i18n.t('common.messages.catalogRequired'));
                _this.$emit("event-loading", false);
                return;
            }
            var orderItems = [];
            for(var p = 0; p < _this.pt180Init.searchList.length; p++){
                var product = _this.pt180Init.searchList[p];
                var order = {};
                order.seqNo = product.SEQ;
                order.lineNo = product.SEQ;
                order.qty = product.QTY;
                order.itemNmHid = product.WEB_ITEM_NM
                order.sItemNo = product.M_ITEM_CD;
                order.cartAddKbn = product.CART_ADD_KBN;
                order.pointFlg = product.POINT_FLG;
                order.riyouPoint = product.RIYO_POINT;
                order.animalQty = product.ANIMAL_QTY;
                order.notSyukkaFlg = product.NOT_SYUKKA_FLG;
                orderItems.push(order);
            }
            for(var p = 0; p < _this.pt180Init.searchPointList.length; p++){
                var product = _this.pt180Init.searchPointList[p];
                var order = {};
                order.seqNo = product.SEQ;
                order.lineNo = product.SEQ;
                order.qty = product.QTY;
                order.itemNmHid = product.WEB_ITEM_NM
                order.sItemNo = product.M_ITEM_CD;
                order.cartAddKbn = product.CART_ADD_KBN;
                order.pointFlg = product.POINT_FLG;
                order.riyouPoint = product.RIYO_POINT;
                order.animalQty = product.ANIMAL_QTY;
                order.notSyukkaFlg = product.NOT_SYUKKA_FLG;
                orderItems.push(order);
            }

            var reqModel = {};
            
            reqModel.processType = _this.BUY_STEP_PROCESS;
            reqModel.orderItems = orderItems;
            reqModel.catalogCd = _this.pt180ReqModel.catalogCd;
            _this.listReport = [];
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT180 + _this.$UrlConstants.DO_NEXT_BUY_STEPS, reqModel).then(function(response) {
                if(response.data.errList != null && response.data.errList.length > 0){
                    _this.displayWaring(response.data.errList);
                }
                if(response.data.status == 'OK'){
                    // 非ログインの場合ログイン画面へ
                    if (_this.isGuestKokyaku(response.data.response.kokyakuNo)) {
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 18}});
                    } else {
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 22},params: {backPageNo:16, quotationFlg: _this.pt180Init.quotationFlg} });
                   }
                } else{
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 16}});
                }
                
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if(406 == error.response.status){
                            var resultValid = common.excuteValidationEcSite(error, _this.SH060_PART);
                            if(resultValid){
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                            common.scrollTop();
                        }else{
                            common.errorAPI(error);
                        }
                    }
                }
            });
        }
    },
    created() {
        var pt180StoreState = this.$store && this.$store.state && this.$store.state.pt180;
        if (pt180StoreState && pt180StoreState.pt180Init && Object.keys(pt180StoreState.pt180Init).length > 0) {
            this.pt180Init = Object.assign({}, this.pt180Init, pt180StoreState.pt180Init);
        }
        if (pt180StoreState && pt180StoreState.pt180ReqModel && Object.keys(pt180StoreState.pt180ReqModel).length > 0) {
            this.pt180ReqModel = Object.assign({}, this.pt180ReqModel, pt180StoreState.pt180ReqModel);
        }
        var queryData = this.$route.query;
        if(Object.keys(queryData).length > 0){
            this.pt180ReqModel = Object.assign({}, this.pt180ReqModel, queryData);
        }

        if (this.$route.params.backPageNo) {
            this.backPageNo = this.$route.params.backPageNo;
        }
        if (this.$route.params.categoryCd) {
            this.categoryCd = this.$route.params.categoryCd;
        }
        if (this.$route.params.ptPageNo) {
            this.ptPageNo = this.$route.params.ptPageNo;
        }
        if (this.$route.params.ptPageSize) {
            this.ptPageSize = this.$route.params.ptPageSize;
        }
        if (this.$route.params.searchItemNm) {
            this.searchItemNm = this.$route.params.searchItemNm;
        }
        if (this.$route.params.itemNmOnly) {
            this.itemNmOnly = this.$route.params.itemNmOnly;
        }
        if (this.$route.params.priceS) {
            this.priceS = this.$route.params.priceS;
        }
        if (this.$route.params.priceE) {
            this.priceE = this.$route.params.priceE;
        }
        if (this.$route.params.allergyMaterialKbn) {
            this.allergyMaterialKbn = this.$route.params.allergyMaterialKbn;
        }
        if (this.$route.params.zaikoSearchFlg) {
            this.zaikoSearchFlg = this.$route.params.zaikoSearchFlg;
        }
        
        if(this.$route.params && this.$route.params.info) {
            var info = "";
            for(var mesg = 0;  mesg < this.$route.params.info.length; mesg++ ){
                info = info + this.$route.params.info[mesg].messageList[0].message;
                info = info + '\n';
            }
            alert(info);
            this.pt440Info = info;
        }
    }
}
</script>
